/** Saves Accounts Balances
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCES = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** Saves Batchfile Transfer List
@payload { Array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_batchfilesearch
*/
export const SAVE_BATCH_FILE_TRANFER_LIST = (state, { pageNumber, data }) => {
    state.batchfileTransferList = pageNumber === 1 ? data.batchFiles : state.favoritesList.concat(data.batchFiles)
    state.batchfileTransferListHasMore = state.batchfileTransferList.length < data.total
}

/** Saves Batchfile Files Types List
@payload { Array } - Não há documentação
*/
export const SAVE_BATCH_FILES_TYPES_LIST = (state, payload) => {
    state.batchfileFileTypeList = payload.fileTypes
}

/** saves the transfers list
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_transfers
*/
export const SAVE_TRANSFERS_LIST = (state, payload) => {
    state.transfersList = payload.transfers
}

/** saves the favorites list
@payload { Object } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_favoriteslist
*/
export const SAVE_FAVORITES_LIST = (state, { pageNumber, data }) => {
    state.favoritesList = pageNumber === 1 ? data.favorites : state.favoritesList.concat(data.favorites)
    state.favoritesHasMore = state.favoritesList.length < data.total
}

/** Saves Batchfile Operations Types List
@payload { Array } - Não há documentação
*/
export const SAVE_OPERATION_TYPES = (state, payload) => {
    state.operationTypes = payload.batchFileEntryOperationTypeViews
}

/** Saves Batchfile Transaction Types
@payload { Array } - Não há documentação
*/
export const SAVE_BATCHFILE_TRANSACTION_TYPES = (state, payload) => {
    state.batchfileTransferTypeList = payload.batchFileEntryTransactionTypeViews
}

/** Saves Batchfile Motives List
@payload { Array } - Não há documentação
*/
export const SAVE_BATCHFILE_MOTIVES = (state, payload) => {
    state.batchfileMotivesList = payload.motives
}

/** Saves Batchfile Categories List
@payload { Array } - Não há documentação
*/
export const SAVE_BATCHFILE_CATEGORIES = (state, payload) => {
    state.batchfileCategoriesList = payload.categories
}

/* ***********************************************
*                  CLEAR MUTATIONS               *
*********************************************** */
export const CLEAR_FEATURE_STATE = (state, payload) => {
    state.accountsBalances = []
    state.batchfileTransferList = []
    state.batchfileFileTypeList = []
    state.operationTypes = []
    state.batchfileTransferTypeList = []
    state.batchfileCategoriesList = []
    state.batchfileMotivesList = []
}
